<template>
  <div id="warningTimeout" class="modal fade" role="dialog">
    <div class="modal-dialog profile-confirm-poup">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header confirmpopup-bgcolor p-0">
          <div class="add-record-title">
            <div>{{ $t('sessionTimeout') }}</div>
            <div @click="closeModal()" class="close-icon cursor-pointer">
              <img src="/static/images/icons/ul_close_icon.svg" class="address-images" />
            </div>
          </div>
        </div>

        <div class="modal-body confirm-body">
          <div class="cancel-message">{{ $t('sessionMessage1') }} {{gettime}} {{ $t('sessionMessage2') }}</div>
          <div class="proceed-title pb-23">
            {{ $t('sessionConfirm') }}
          </div>

        </div>
        <div class="modal-footer confirmpopup-bgcolor col-xs-12 col-sm-12 d-flex-sm-end">
          <div class="">
            <button type="button" class="btn btn-block cancel-changes" @click="loadLogOut">{{ $t('logout') }}</button>
          </div>

          <div class="">
            <button type="button" class="btn btn-block proceed-changes" data-dismiss="modal"
                data-toggle="tab"
                data-target="#warningTimeout" @click="loadAgain">{{ $t('stayConnected') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  data() {
    return {
      gettime: 30,
      warningOut: 1,
    };
  },
  mounted() {
    $('#warningTimeout').on('show.bs.modal', this.makeTimeOut);
    $('#warningTimeout').on('hidden.bs.modal', () => {
      clearInterval(this.warningOut);
      this.warningOut = undefined;
      $('.modal-backdrop').remove();
    });
  },
  beforeDestroy() {
    clearInterval(this.warningOut);
  },
  methods: {
    closeModal() {
      $('#warningTimeout').modal('hide');
    },
    makeTimeOut() {
      this.gettime = 30;
      clearInterval(this.warningOut);
      this.warningOut = setInterval(this.warningTime, 1000);
    },
    warningTime() {
      if (this.gettime > 0) {
        this.gettime -= 1;
      }
      if (this.gettime === 0) {
        clearInterval(this.warningOut);
        this.warningOut = undefined;
        this.loadLogOut();
      }
    },

    loadLogOut() {
      socket.removeAllListeners(`alertSaveMultiRegistrationDetails_${localStorage.getItem('userId')}`);
      document.cookie = 'Authorization=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      document.cookie = 'redirect_url=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      localStorage.clear();
      sessionStorage.clear();
      $('#warningTimeout').modal('hide');
      this.$router.push('/login');
    },
    loadAgain() {
      clearInterval(this.warningOut);
      this.warningOut = undefined;
      localStorage.setItem('removeIdlePopups', true);
    },
  },
};
</script>

<style scoped>
.cancel-message {
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  color: #333333;

}
label {
    display: inline-block;
    max-width: 100%;
    margin-bottom: 0px !important;
    /* font-weight: 700; */
}
.modal-header {
    background-color: #ffffff !important;
    border-bottom: 1px solid #d3d3d3 !important;
    border-top-right-radius: 6px!important;
    border-top-left-radius: 6px!important;
}

.modal-header .close {
    background: unset;
    opacity: 1;
    line-height: unset;
    width: unset;
    border-radius: unset;
    color: unset;
    background-color: #ffffff !important;
}

.add-record-title {
    display: flex;
    justify-content: space-between;
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
    color: #1A1A1A;
    padding: 17px 0px 17px 16px;
}
.close-icon {
    padding-right: 16px;
}

.proceed-title {
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #333333;
    padding-top:16px
}

.modal-body {
    padding: 16px 28px 0px 20px;
}

.market-title {
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    color: #3e3e3e;
}

label>input[type="radio"] {
    display: none;
}

label>input[type="radio"]+*::before {
    content: "";
    display: inline-block;
    vertical-align: bottom;
    width: 18px;
    height: 18px;
    margin-right: 11px;
    margin-bottom: 4px;
    border-radius: 50%;
    border-style: solid;
    border-width: 1px;
    border-color: #00518a;
    border: 2px solid #4d4d4d;
}

label>input[type="radio"]:checked+*::before {
    background: radial-gradient(#00518a 0%, #00518a 46%, transparent 51%, transparent);
    border-color: #00518a;
    border: 2px solid #00518a;
}

.proceed-changes,
.proceed-changes:hover {
    background-color: #01518a;
    height: 44px;
    min-width: 127px;
    color: #ffffff !important;
    font-size: 18px;
    font-weight: 600;
    border-radius: 3px;
    line-height: 25px;
    float: right;
    cursor: pointer;
    padding: 10px 16px;
    /* text-transform: capitalize; */
}

.cancel-changes,
.cancel-changes:hover {
    background-color: #e6e6e6;
    height: 44px;
    min-width: 171px;
    color: #404040 !important;
    font-size: 18px;
    font-weight: 600;
    border-radius: 3px;
    line-height: 24px;
    float: right;
    cursor: pointer;
    padding: 10px 16px;
}

.modal-footer {
    background-color: #fafaf9 !important;
    padding-right: 0px;
    border: none !important;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
}
.modal-content {
 border: none;
 border-top-right-radius: 6px!important;
 border-top-left-radius: 6px!important;
 border-bottom-right-radius: 0!important;
 border-bottom-left-radius: 0!important;
}

.pb-23 {
 padding-bottom: 23px;
}
.pb-21 {
 padding-bottom: 21px;
}
.radio-buttons {
 padding-left: 19px;
 padding-bottom: 27px;
}

@media (min-width: 768px) {
.modal-dialog {
 width: 500px;
 margin: 30px auto;
}
}
</style>
